import React from 'react'
import cn from 'classnames'

import Linka from 'client/shared/blocks/linka'
import urlFor, { QueryParams } from 'shared/tools/url-helper'
import BookStatus from 'client/shared/blocks/book-status'
import bookHelper from 'shared/tools/book-helper'
import { BookProps } from 'client/shared/types/book'

type Props = {
  locale: string
  canSerialBeRead: boolean
  hasAccess: boolean
  id?: string
  onClick?: () => void
  episode: BookProps
  query?: QueryParams
}
export default ({
  locale,
  canSerialBeRead,
  hasAccess,
  id,
  onClick,
  query,
  episode: {
    uuid,
    can_be_read,
    position,
    title,
    publication_date,
    library_card,
    parent_uuid,
  },
}: Props): JSX.Element => (
  <div
    id={id}
    onClick={onClick}
    className={cn('serial-episode', {
      'serial-episode_inactive': !can_be_read || !canSerialBeRead,
    })}
  >
    <div className="serial-episode__number">{position}</div>
    <div className="serial-episode__item-wrapper">
      <Linka
        path={urlFor.reader(
          parent_uuid,
          {
            resourceType: 'serial',
          },
          { episode: position, episode_uuid: uuid, ...query },
        )}
        target="_blank"
      >
        <div className="serial-episode_name">{title}</div>
      </Linka>
      <div className="serial-episode__status">
        {!can_be_read && publication_date ? (
          <div className="serial-episode__status_date">
            {Intl.DateTimeFormat(locale, {
              month: 'long',
              day: '2-digit',
            }).format(new Date(publication_date * 1000))}
          </div>
        ) : (
          <BookStatus
            progress={
              bookHelper.inProgress(library_card) ? library_card.progress : null
            }
            isFinished={bookHelper.isFinished(library_card)}
            isPrivate={!hasAccess}
            isSerial
          />
        )}
      </div>
    </div>
  </div>
)
